<template>
  <div class="hy-index2">
    <!--logo-->
    <div class="index_logo">
      <router-link to="/">
        <img :src="logoImg " alt="">
      </router-link>
    </div>
    <!--搜索-->
    <van-sticky>
      <div class="index-searchbox">
        <van-search v-model="searchValue" :clearable=false background="#FFF" placeholder="输入关键字，搜索讲座" @search="onSearch" class="search2"/>
        <div class="rightBtn" @click='onSearch'>
          <van-icon name="search" />
        </div>
      </div>
    </van-sticky>
    <!--列表-->
    <div class="index-list">
      <div class="rows">
        <h5 class="index-title">
          搜索结果
          <span>SEARCH RESULT</span>
        </h5>
        <div class="hy_nolist" v-if="datacount > 0 && searchValue != ''">
          <p>
            您搜索的“<span>{{searchValueShow}}</span>”相关的内容，共有<span>{{datacount}}</span>条
          </p>
        </div>
        <div class="list_type" v-show="hidden">
          <div class="type_rows" v-for="(items2,index) in  navigation">
            <b>{{items2.name}}：</b>
            <div class="items_list">
              <template v-for="(items3,key,index2) in items2.list" v-if="navigationChange[index].list.length >0">
                <a href="javascript:;" :class="navigationChange[index].list[index2] != '' ?'active':''" @click="navigatio0n(index,index2,key)">{{items3}}</a>
              </template>
            </div>
          </div>
        </div>
        <van-list v-model="loading" :finished="finished" :finished-text="moreText" @load="onLoad">
          <van-cell v-for="items in data" :key="items.id" v-if="data.length > 0">
            <a class="more-link" :href="'/index/conference/template?id='+items.id">
              <div class="imgbox">
                <img :src="items.cover_url" alt />
                <div class="typeFixed">
                  <span>{{items.status_str }}</span> |
                  <span class="type">{{items.type_str}}</span>
                </div>
              </div>
              <div class="textbox">
                <div class="title">
                  <h5>{{items.name}}</h5>
                </div>
                <div class="textinfo">
                  <span class="l"> {{items.province_name}}</span>
                  <span class="r">{{items.form_str}}</span>
                </div>
                <div class="textinfo">
                  {{items.start_time ,'Y年M月D日'|formatDates}}~ {{items.end_time ,'Y年M月D日'|formatDates}}
                </div>
              </div>
            </a>
          </van-cell>
        </van-list>
       <div class="hy_nolist bottomPx" v-if="data.length == 0 && loading == false">
         <p v-if="searchValueShow != ''">
            未搜索到与“<span>{{searchValueShow}}</span>”相关的内容
          </p>
         <p v-else>
           未搜索到相关的内容
         </p>
        </div>
      </div>
    </div>
    <div class="index-list" v-if="data.length == 0">
      <div class="rows">
        <h5 class="index-title">为您推荐 <span>RECOMMENDED FOR YOU</span></h5>
        <van-list>
          <van-cell v-for="items in tuiList" :key="items.id" v-if="tuiList.length > 0">
            <a class="more-link" :href="'/index/conference/template?id='+items.id">
              <div class="imgbox">
                <img :src="items.cover_url" alt />
                <div class="typeFixed">
                  <span>{{items.status_str }}</span> |
                  <span class="type">{{items.type_str}}</span>
                </div>
              </div>
              <div class="textbox">
                <div class="title">
                  <h5>{{items.name}}</h5>
                </div>
                <div class="textinfo">
                  <span class="l"> {{items.province_name}}</span>
                  <span class="r">{{items.form_str}}</span>
                </div>
                <div class="textinfo">
                  {{items.start_time ,'Y年M月D日'|formatDates}}~ {{items.end_time ,'Y年M月D日'|formatDates}}
                </div>
              </div>
            </a>
          </van-cell>
        </van-list>
      </div>
    </div>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <span class="iconfont fixed-link" @click="openFooterNav()">&#xe60c;</span>
      <div class="hy_footer_nav" :class="footerNav? 'active':''">
        <router-link class="nav-link iconfont" to="/">
          &#xe60e;
          <span class="text">会议平台首页</span>
        </router-link>
        <router-link class="nav-link iconfont" to="/myEnroll">
          &#xe609;
          <span class="text">我的会议信息</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    formatDates
  } from "../../assets/js/date";
  export default {
    data() {
      return {
        logoImg:require('../../assets/images/2.0/mlogo_2.0.png'),
        /* 搜索关键字 */
        searchValueShow:'',
        searchValue: "",
        navigation:[],
        navigationChange:[],
        /* 搜索数据 */
        data: [],
        datacount:0,
        /* 暂存搜索数据 */
        allList: [],
        /* 推荐数据 */
        tuiList: [],
        moreText: '没有更多了',
        loading: false,
        finished: false,
        footerNav: false,
        /* 页码 */
        page: 1,
        /* 每页条数 */
        pagesize: 5,
        /* 总页数 */
        total: 0,
        hidden:true,
        type:[],
        form:[],
        subject:[],
        status:[],
      };
    },
    created() {
      if(this.$route.query.text){
        this.searchValue = this.$route.query.text;
        this.searchValueShow = this.$route.query.text;
      }
      this.infoPage();
    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
      navigatio0n(i,i2,key){
        let _this = this;
        if(_this.navigationChange[i].list[i2] == ''){
          _this.$set(_this.navigationChange[i].list,i2,key);
        }else{
          _this.$set(_this.navigationChange[i].list,i2,'');
        }
        _this.data =[];
        _this.page = 1;
        _this.finished = false;
        _this.reashbox();
        _this.onSearch();
      },
      reashbox(){
        let _this = this;
        _this.type=[];
        _this.form=[];
        _this.subject=[];
        _this.status=[];
        for(var i =0;i<_this.navigationChange.length;i++){
          for(var h=0;h<_this.navigationChange[i].list.length;h++){
            if(_this.navigationChange[i].type == 'type' && _this.navigationChange[i].list[h] != ''){
              _this.type.push(_this.navigationChange[i].list[h]);
            }
            if(_this.navigationChange[i].type == 'form' && _this.navigationChange[i].list[h] != ''){
              _this.form.push(_this.navigationChange[i].list[h]);
            }
            if(_this.navigationChange[i].type == 'subject' && _this.navigationChange[i].list[h] != ''){
              _this.subject.push(_this.navigationChange[i].list[h]);
            }
            if(_this.navigationChange[i].type == 'status' && _this.navigationChange[i].list[h] != ''){
              _this.status.push(_this.navigationChange[i].list[h]);
            }
          }
        }
      },
      //banner跳转方法
      goPath(path) {
        if (path == "") {
          return false;
        }
        this.$router.push(path);
      },
      infoPage(){
        let _this = this;
        let url = "/ac1/conference/search2";
        let params = {
          page: _this.page,
          pagesize: _this.pagesize,
          keyword: _this.searchValue,
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.navigation = res.posts.navigation;

            for(var i=0;i<_this.navigation.length;i++){
              var typelist = _this.navigation[i].list;
              var newLit = {
                type:_this.navigation[i].filed,
                list:[]
              };
              for(var h in typelist){
                newLit.list.push('');
              }
              _this.navigationChange.push(newLit);
            }
          }else{
            _this.$toast(res.msg);
          }
        });
      },
      //搜索方法
      onSearch( ) {
        let _this = this;
          _this.data =[];
          _this.finished = false;
          _this.page = 1;
          _this.hidden = true;
          let url = "/ac1/conference/search2";
          let params = {
            page: _this.page,
            pagesize: _this.pagesize,
            keyword: _this.searchValue,
            type:_this.type,
            form:_this.form,
            subject: _this.subject,
            status:_this.status,
          };
          _this.$get(url, params).then(res => {
            if (res.code == "1") {
              // 加载状态结束
              _this.loading = false;
              if (res.posts.data.length < _this.pagesize) {
                _this.moreText = '没有更多了';
                _this.finished = true;
              }
              if(res.posts.data.length == 0){
                _this.moreText = '';
                _this.hidden = false;
              }
              _this.data = res.posts.data;
              _this.tuiList = res.posts.recommended;
              _this.datacount = res.posts.count;
              _this.searchValueShow = _this.searchValue
            }
          });
      },
      //热门咨询加载
      onLoad() {
          var _this = this;
          let url = "/ac1/conference/search2";
          let params = {
            page: _this.page,
            pagesize: _this.pagesize,
            keyword: _this.searchValue,
            type:_this.type,
            form:_this.form,
            subject: _this.subject,
            status:_this.status,
          };
          _this.$get(url, params).then(res => {
            if (res.code == "1") {
              // 加载状态结束
              _this.loading = false;
              if (res.posts.data.length < _this.pagesize) {
                _this.moreText = '没有更多了';
                _this.finished = true;
              }
              _this.allList = res.posts.data;
              _this.datacount = res.posts.count;
              _this.allList.forEach(v => {
                _this.data.push(v);
              });
              _this.page = _this.page + 1;
            }
          });
      },
      //打开底部链接
      openFooterNav(val) {
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      }
    }
  };
</script>
<style lang="less" scoped>
</style>
